module.exports = "/_next/static/images/CombineData@2x-01caa829007916bef42430342b75fa9e.webp";